// 备课系统 zip文件预览
<template>
  <div class="office-preview">
    <div class="container-in clearfix">
      <div class="iframe-wrap">
        <iframe
          id="iframe"
          :src="url"
          frameborder="0"
          width="100%"
          height="690px"
          allowfullscreen="true">
        </iframe>
      </div>
    </div>
  </div>
</template>
<script>

import {bkResource} from '@/utils/constant'
import { md5Encrypt } from '@/utils/tools'
export default {
  name: 'c-zip-preview',
  props: {
    file: {
      type: Object,
      default () {
        return {}
      }
    },
    fileUrl: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      url: ''
    }
  },
  mounted () {
    this.geturl();
  },
  methods: {
    geturl() {
      const baseUrl = '//preview.jkxjxw.com';
      let md5Key = md5Encrypt(this.file.id)
      let zipUrl = bkResource + `${this.file.id}/preview/filename${md5Key}.${this.file.suffixType}`
      this.url = baseUrl + '/onlinePreview?url=' + encodeURIComponent(btoa(zipUrl))
    }
  }
}
</script>
<style lang="scss" scoped>
.office-preview {
  position: relative;
  z-index: 10;
  height: 690px;
  overflow: hidden;
  background: rgba(255,255,255,1);
}
.iframe-wrap {
  position: relative;
  height: 690px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.max-size {
  font-size: 18px;
}
.wrapper {
  position: absolute;
  left: 46px;
  top: 90px;
  height: 578px;
  width: 814px;
  background-color: transparent;
  z-index: 99999;
}
#GiveFeedback{
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/preview/components/CZipPreview.vue